import { RootState } from "@src/reducers/store";
import { updateModalsCloseDrawerModal } from "@src/reducers/your-reducer";
import { setConnectedGatewaysWithMachinesListData } from "@src/reducers/gateways-machines-slice";
import { useDispatch, useSelector } from "react-redux";
import {
  resetOnboardingState,
  setGatewayDetails,
} from "@src/reducers/onboarding-slice";
import { GatewayWithMachinesViewStateTypes } from "@src/types/gateways-with-machines";
import { useI18N } from "@src/language/language-context";

export const useGatewaysListRowHook = (
  gatewayData: GatewayWithMachinesViewStateTypes,
) => {
  const dispatch = useDispatch();
  const i18n = useI18N();

  const connectedGatewaysListData = useSelector(
    (state: RootState) => state.gatewaysMachinesSlice.connectedGatewaysListData,
  );

  const toggleSourcesVisibility = () => {
    const newConnectedGatewaysListData = connectedGatewaysListData.map(
      (gateway) => {
        if (gatewayData.gateway_uuid === gateway.gateway_uuid) {
          return { ...gateway, sources_visible: !gateway.sources_visible };
        }
        return gateway;
      },
    );

    dispatch(
      setConnectedGatewaysWithMachinesListData(newConnectedGatewaysListData),
    );
  };

  const handleAddMachineClick = () => {
    dispatch(resetOnboardingState());
    dispatch(
      setGatewayDetails({
        gateway_id: gatewayData.gateway_uuid,
        name: gatewayData.name,
        vendor_id: gatewayData.vendor_id,
      }),
    );
    dispatch(
      updateModalsCloseDrawerModal({
        showModal: true,
        id: "addNewMachineDrawerModal",
      }),
    );
  };

  const texts = {
    gatewayIconAltText: i18n("modules.gatewaysListRow.gatewayIconAltText"),
    addMachineText: i18n("modules.gatewaysListRow.addMachineText"),
    addMachineTooltip: i18n("modules.gatewaysListRow.addMachineTooltip"),
    noVendorIDAvailable: i18n("modules.gatewaysListRow.noVendorIDAvailable"),
    copyGatewayUuid: i18n("modules.userCredentialsModal.copyTooltip"),
    gatewayUuidCopied: i18n("modules.machinesListRow.successMessage"),
    gatewayUuidCopyError: i18n("modules.machinesListRow.errorMessage"),
  };

  return {
    toggleSourcesVisibility,
    handleAddMachineClick,
    texts,
  };
};
